import {executeWithIntercept, onRedirect, pageData, RouteData} from "@/helpers/CypressHelper";
import RentaEasyConstants from "@/helpers/RentaEasyConstants";
import Localizer from "@/localization/Localizer";

describe('Desktop - Authenticated construction site details feature flags tests', () => {
    beforeEach(() => {
        cy.useSharedAdminUserSession();

        cy.visit('frontpage');
    });

    describe('Nothing disabled test', () => {
        it('Should display all tabs when all flags are enabled', () => {
            onRedirect(() => {
                executeWithIntercept(() =>
                        cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=f7422461-9c46-416d-b500-7ab6ae1ee591`),
                    [pageData().constructionSite.routes.getConstructionSiteDetails as RouteData]
                );
            });


            pageData().constructionSite.status.tab();
            pageData().constructionSite.equipment.tab();
            pageData().constructionSite.invoices.tab();
            pageData().constructionSite.users.tab();
            pageData().constructionSite.serviceRequests.tab();
            pageData().constructionSite.environmentControl.tab();
            pageData().constructionSite.emissions.tab();
            pageData().constructionSite.power.tab();

        });
    });

    describe('Disabled flags test', () => {

        it('Should display all tabs when all flags are enabled', () => {
            pageData().common.interceptFeatureFlags([
                {flagName: RentaEasyConstants.featureFlagCo2Enabled, enabled: false},
                {flagName: RentaEasyConstants.featureFlagEnvironmentControl, enabled: false},
                {flagName: RentaEasyConstants.featureFlagServicesView, enabled: false},
                {flagName: RentaEasyConstants.featureFlagConstructionSiteStatusPage, enabled: false},
                {flagName: RentaEasyConstants.featureFlagConstructionSitePowerPage, enabled: false}
            ])
            onRedirect(() => {
                executeWithIntercept(() =>
                        cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=f7422461-9c46-416d-b500-7ab6ae1ee591`),
                    [pageData().constructionSite.routes.getConstructionSiteDetails as RouteData]
                );
            });


            pageData().constructionSite.status.tab().should('not.exist');
            pageData().constructionSite.equipment.tab();
            pageData().constructionSite.invoices.tab();
            pageData().constructionSite.users.tab();
            pageData().constructionSite.serviceRequests.tab().should('not.exist');
            pageData().constructionSite.environmentControl.tab().should('not.exist');
            pageData().constructionSite.emissions.tab().should('not.exist');
            pageData().constructionSite.power.tab().should('not.exist');

        });

        it('Should display new user invitation modal when flag is enabled', () => {

            const response = {
                "value": {
                    "alertMessage": "Role(s) added to user, invite sent to address: example@gmail.com \n\n",
                    "errorMessage": "",
                    "tokenUrls": []
                },
                "context": null,
                "newVersionAvailable": false,
                "redirect": null,
                "error": null,
                "alert": null,
                "unauthorized": false,
                "isResponseContainer": true
            };

            cy.intercept('POST', '/api/Users/InviteUser', { statusCode: 200, body: response }).as('saveRequest');

            pageData().common.interceptFeatureFlags([
                {flagName: RentaEasyConstants.featureFlagUserInvitationModal, enabled: true},
            ])
            onRedirect(() => {
                executeWithIntercept(() =>
                        cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=f7422461-9c46-416d-b500-7ab6ae1ee591`),
                    [pageData().constructionSite.routes.getConstructionSiteDetails as RouteData]
                );
            });

            pageData().constructionSite.users.tab().click();

            pageData().constructionSite.users.buttons.inviteUsers().click()

            pageData().inviteUser.userInvitationModal()
                .should('be.visible')
                .find('.modal-title')
                .should('contain', Localizer.userInvitationModalTitle);

            cy.get('label[data-cy="customerName"]')
                .should('contain', 'Tmi Jukka Wilska - 2798958-4');

            cy.get('label[data-cy="constructionSiteName"]')
                .should('contain', 'Testitilaus Renta Easy');

            cy.get('div[data-cy="user-invitation-modal-radio-buttons"]')
                .should('exist')
                .children()
                .should('have.length', 2);

            // Default case. No radio button is selected.
            pageData().inviteUser.existingEasyUserRadio().verifyDataValue('false');
            pageData().inviteUser.newEasyUserRadio().verifyDataValue('false');
            pageData().inviteUser.addUserButton().should('be.disabled');

            // Click on existing user and verify data.
            pageData().inviteUser.existingEasyUserRadio().click();
            pageData().inviteUser.existingEasyUserRadio().verifyDataValue('true');
            pageData().inviteUser.selectUserDropdown().should('exist');
            pageData().inviteUser.selectUserDescription()
                .should('contain.text', Localizer.userInvitationModalUserSelectUserDescription);
            selectUserFromList('nen', 0);
            pageData().inviteUser.addUserButton().click();
            pageData().inviteUser.selectUserError().should('not.exist');

            // Check validation error.
            pageData().inviteUser.existingEasyUserRadio().click();
            selectUserFromList('nen', 0);
            pageData().inviteUser.addUserButton().click();
            pageData().inviteUser.selectUserError()
                .should('exist')
                .should('contain.text', Localizer.userInvitationModalUserUserAlreadyInList);
            pageData().inviteUser.addUserButton().should('not.be.disabled');

            // Select other user from the list.
            pageData().inviteUser.existingEasyUserRadio().click();
            selectUserFromList('nen', 2);
            pageData().inviteUser.addUserButton().click();
            pageData().inviteUser.selectUserError().should('not.exist');

            // Click on new user and verify data.
            pageData().inviteUser.newEasyUserRadio().click();
            pageData().inviteUser.newEasyUserRadio().verifyDataValue('true');
            addNewUser('email@example.com');
            pageData().inviteUser.addUserButton().click();

            // Check validation error.
            pageData().inviteUser.newEasyUserRadio().click();
            addNewUser('email@example.com');
            pageData().inviteUser.addUserButton().click();
            pageData().inviteUser.emailError()
                .should('exist')
                .should('contain.text', Localizer.userInvitationModalUserUserAlreadyInList);
            pageData().inviteUser.addUserButton().should('not.be.disabled');

            // Check that radio buttons clear the form.
            pageData().inviteUser.existingEasyUserRadio().click();
            pageData().inviteUser.addUserButton().should('be.disabled');
            pageData().inviteUser.newEasyUserRadio().click();
            pageData().inviteUser.firstNameInput().should('have.value', '');
            pageData().inviteUser.lastNameInput().should('have.value', '');
            pageData().inviteUser.emailInput().should('have.value', '');
            pageData().inviteUser.phoneInput().should('have.value', '');
            pageData().inviteUser.addUserButton().should('be.disabled');

            // Check invite list.
            pageData().inviteUser.emailList()
                .should('have.length', 3)
                .should('contain.text', 'invited.user2@domain.fi')
                .should('contain.text', 'juhani.sihvonen@weare.fi')
                .should('contain.text', 'email@example.com');

            // Delete user from the list.
            pageData().inviteUser.removeUserButton().eq(1).click();

            // Check invite list.
            pageData().inviteUser.emailList()
                .should('have.length', 2)
                .should('contain.text', 'invited.user2@domain.fi')
                .should('contain.text', 'email@example.com');

            // Check permissions.
            pageData().inviteUser.organizationUser().should('not.exist');
            pageData().inviteUser.mainRoleCheckbox().should('exist');
            pageData().inviteUser.checkboxDescription().should('contain', Localizer.userInvitationModalPermissionsConstructionSiteMainRoleDescription);
            pageData().inviteUser.noRentApprovalCheckbox().should('exist');
            pageData().inviteUser.checkboxDescription().should('contain', Localizer.userInvitationModalPermissionsNoRentApprovalDescription);
            pageData().inviteUser.canSeePricesCheckbox().should('exist');
            pageData().inviteUser.selectConstructionSitesDropdown().should('not.exist');

            // If "Construction site main user role" is selected,
            // then select and disable the "Does not need approval to rent" and "Can see contract prices" checkboxes.
            pageData().inviteUser.mainRoleCheckbox().click();
            pageData().inviteUser.noRentApprovalCheckbox().verifyDataValue('true');
            pageData().inviteUser.noRentApprovalCheckbox()
                .children('div')
                .eq(0)
                .should('have.attr', 'disabled');
            pageData().inviteUser.canSeePricesCheckbox().verifyDataValue('true');
            pageData().inviteUser.canSeePricesCheckbox()
                .children('div')
                .eq(0)
                .should('have.attr', 'disabled');

            pageData().inviteUser.cancelButton().should('exist');
            pageData().inviteUser.saveButton()
                .should('exist')
                .click();

            cy.wait('@saveRequest').then(({ request }) => {
                expect(request.body.accessToAllConstructionSites).to.equal(false);
                expect(request.body.companyMainUserRole).to.equal(true);
                expect(request.body.contractId).to.equal('31eaa6c0-42fa-40c2-a891-bcd16c367409');

                expect(request.body).to.have.nested.property('constructionSiteAccesses')
                expect(request.body.constructionSiteAccesses).to.have.length(1);
                expect(request.body.constructionSiteAccesses[0].fullAccess).to.equal(true);
                expect(request.body.constructionSiteAccesses[0].directRentAccess).to.equal(true);
                expect(request.body.constructionSiteAccesses[0].pricesVisible).to.equal(true);

                expect(request.body).to.have.nested.property('usersList')
                expect(request.body.usersList).to.have.length(2);
                expect(request.body.usersList[0].email).to.equal('invited.user2@domain.fi');
                expect(request.body.usersList[1].email).to.equal('email@example.com');
            });

            pageData().inviteUser.saveError().should('not.exist');
        });

        it('Should display new user invitation modal, close and open', () => {
            pageData().common.interceptFeatureFlags([
                {flagName: RentaEasyConstants.featureFlagUserInvitationModal, enabled: true},
            ])
            onRedirect(() => {
                executeWithIntercept(() =>
                        cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=f7422461-9c46-416d-b500-7ab6ae1ee591`),
                    [pageData().constructionSite.routes.getConstructionSiteDetails as RouteData]
                );
            });

            pageData().constructionSite.users.tab().click();

            pageData().constructionSite.users.buttons.inviteUsers().click();

            pageData().inviteUser.userInvitationModal()
                .should('be.visible')
                .find('.modal-title')
                .should('contain', Localizer.userInvitationModalTitle);

            pageData().inviteUser.saveButton().should('exist');// should be disabled

            // Add one existing user.
            pageData().inviteUser.existingEasyUserRadio().click();
            pageData().inviteUser.existingEasyUserRadio().verifyDataValue('true');
            pageData().inviteUser.selectUserDropdown().should('exist');
            selectUserFromList('nen', 0);
            pageData().inviteUser.addUserButton().click();

            // Check invite list.
            pageData().inviteUser.emailList()
                .should('have.length', 1)
                .should('contain.text', 'invited.user2@domain.fi');

            pageData().inviteUser.noRentApprovalCheckbox()
                .click()
                .verifyDataValue('true');
            pageData().inviteUser.canSeePricesCheckbox()
                .click()
                .verifyDataValue('true');

            pageData().inviteUser.saveButton().should('exist');// should not be disabled
            pageData().inviteUser.cancelButton()
                .should('exist')
                .click();

            pageData().constructionSite.users.buttons.inviteUsers().click();

            pageData().inviteUser.emailList()
                .should('have.length', 0);

            pageData().inviteUser.noRentApprovalCheckbox().verifyDataValue('false');
            pageData().inviteUser.canSeePricesCheckbox().verifyDataValue('false');
        });
    });

    function addNewUser(email: string) {
        pageData().inviteUser.firstNameInput().type("name");
        pageData().inviteUser.lastNameInput().type("last name");
        pageData().inviteUser.emailInput().type(email);
        pageData().inviteUser.phoneInput().type("+351234567890");
    }

    function selectUserFromList(search: string, element: number) {
        pageData().inviteUser.selectUserDropdown().click().type(search);
        pageData().inviteUser.selectUserDropdown().parent().parent().find('div[class*="dropdownOption"]').eq(element).click();
    }

});